import { STRIPE_GLOBAL_AVAILABILITY_URL, STRIPE_SUPPORT_URL } from 'pricing-pages-lib/constants/urls';
import { getAcademyUrlPublic, getAppMarketplaceUrl, getCMSUrlPublic, getCommerceUrlPublic, getCommunityUrlPublic, getDataProcessingAgreementUrl, getDevelopersAndApiDocsBaseUrl, getDevelopersApiDocsUrl, getDevelopersQuickStartGuideUrl, getKBBreezeIntelligenceFAQ, getKBEmbedCTAUrlPublic, getKBExportAdPerformanceData, getKBExportContentAndData, getKBExportMarketingEmailPerformanceData, getKBExportRecords, getKBImportToolUrlPublic, getKBMembershipsUrlPublic, getKBPermanentDelete, getKBShareFormsUrlPublic, getKBTrackingCodeUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMarketingPricingUrlPublic, getMarketingUrlPublic, getMembershipsExamplesUrl, getMicrositesExamplesUrl, getNonprofitsUrlPublic, getOperationsSupportedApplicationsUrl, getOperationsUrlPublic, getPrivacyPolicyUrl, getPrivacyRequestFormUrl, getProductAndServicesUrlPublic, getQBOIntegrationURL, getSalesUrlPublic, getSecurityAndComplianceUrl, getServiceUrlPublic, getSmartCrmAIUrlPublic, getSmartCrmPricingUrlPublic, getSolutionsMarketplaceUrl, getStartupsUrlPublic, getTemplatesMarketplaceUrl, getTrustCenterUrl, getWebsiteMigrationUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import { getCreateABundleUrl, getProductsAndServicesCatalogUrl } from 'pricing-pages-lib/utils/urls';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { NavItemEnum } from '../routing/NavItems';
import { TRACKING_SOURCES } from '../tracking/TrackingSources';
export const FaqsConfig = {
  [NavItemEnum.MARKETING]: [{
    questionKey: 'marketing.whatIsMarketing411',
    getHref: () => getMarketingUrlPublic()
  }, {
    questionKey: 'marketing.whatAreMarketingContacts'
  }, {
    questionKey: 'marketing.howManyContacts411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'marketing.howManyEmails411'
  }, {
    questionKey: 'marketing.requiredOnboarding411'
  }, {
    questionKey: 'marketing.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'marketing.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'marketing.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'marketing.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'marketing.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SALES]: [{
    questionKey: 'sales.whatIsSalesHub411',
    getHref: () => getSalesUrlPublic()
  }, {
    questionKey: 'sales.whatIsFreeVsPaid411'
  }, {
    questionKey: 'sales.howManyUsers411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'sales.salesVsService411'
  }, {
    questionKey: 'sales.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'sales.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'sales.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'sales.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'sales.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SERVICE]: [{
    questionKey: 'service.whatIsServiceHub411',
    getHref: () => getServiceUrlPublic()
  }, {
    questionKey: 'service.whatIsFreeVsPaid411'
  }, {
    questionKey: 'service.howManyUsers411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'service.salesVsService411'
  }, {
    questionKey: 'service.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'service.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'service.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'service.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'service.whenEligibleForNewPricing'
  }],
  [NavItemEnum.CMS]: [{
    questionKey: 'cmsHub.whatIsCMSHub411',
    getHref: () => getMarketingUrlPublic()
  }, {
    questionKey: 'cmsHub.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'cmsHub.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'cmsHub.whatLimits411',
    getHref: () => getProductAndServicesUrlPublic()
  }, {
    questionKey: 'cmsHub.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'cmsHub.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }],
  [NavItemEnum.OPERATIONS]: [{
    questionKey: 'operations.whatIsOperationsHub',
    getHref: () => getOperationsUrlPublic()
  }, {
    questionKey: 'operations.whatSupport',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'operations.whatSupport',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'operations.whatDoesDataSyncDo',
    isJSX: false
  }, {
    questionKey: 'operations.whatTypeOfDataSync',
    getHref: () => getOperationsSupportedApplicationsUrl()
  }, {
    questionKey: 'operations.whatApplicationsSync',
    getHref: () => getOperationsSupportedApplicationsUrl()
  }, {
    questionKey: 'operations.whatIsProgrammableAutomation',
    isJSX: false
  }, {
    questionKey: 'operations.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'operations.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'operations.whenEligibleForNewPricing'
  }],
  [NavItemEnum.FREE]: [{
    questionKey: 'free.whatAreLimits411',
    getPassedInOptions: () => ({
      marketingHref: getMarketingPricingUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'free.whatAreLimits411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'free.emailIntegration411'
  }, {
    questionKey: 'free.howManyContacts411',
    isExternalLink: true,
    getHref: () => {
      return getMarketingPricingUrlPublic();
    }
  }, {
    questionKey: 'free.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'free.whatSupport411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'free.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'free.whatDiscounts411',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'free.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SUITE]: [{
    questionKey: 'crmSuite.whatIsCrmSuite',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'crmSuite.whenEligibleForNewPricing'
  }],
  [NavItemEnum.COMMERCE]: [{
    questionKey: 'commerce.whatIsCommerceHub'
  }, {
    questionKey: 'commerce.saasSubscription',
    getPassedInOptions: () => ({
      pAndSCatalogHref: getProductsAndServicesCatalogUrl(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'commerce.saasSubscription',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      },
      commercePricingPageHref: getCommerceUrlPublic()
    })
  }, {
    questionKey: 'commerce.doINeedASubscription',
    getPassedInOptions: () => ({
      pAndSCatalogHref: getProductsAndServicesCatalogUrl(),
      onCatalogLinkClick: () => {
        trackClickedLink({
          value: 'commerce.doINeedASubscription',
          url: getProductsAndServicesCatalogUrl(),
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'commerce.countryAvailability',
    getPassedInOptions: () => ({
      stripeAvailability: STRIPE_GLOBAL_AVAILABILITY_URL,
      onClickStripeAvailability: () => {
        trackClickedLink({
          value: 'commerce.countryAvailability',
          url: STRIPE_GLOBAL_AVAILABILITY_URL,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'commerce.stripeVsHubSpotPayments'
  }, {
    questionKey: 'commerce.stripeRateNegotiation',
    getPassedInOptions: () => ({
      stripeSupportUrl: STRIPE_SUPPORT_URL,
      onClickStripeSupport: () => {
        trackClickedLink({
          value: 'commerce.stripeRateNegotiation',
          url: STRIPE_SUPPORT_URL,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'commerce.integratingIntoExistingSystem',
    getPassedInOptions: () => ({
      qBOIntegrationHref: getQBOIntegrationURL(),
      onLinkClick: () => {
        trackClickedLink({
          value: 'commerce.integratingIntoExistingSystem',
          url: getQBOIntegrationURL(),
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }],
  [NavItemEnum.CONTENT]: [{
    questionKey: 'content.whatIsContentHub',
    getHref: () => getCMSUrlPublic(true)
  }, {
    questionKey: 'content.existingWebsite',
    getPassedInOptions: () => ({
      appMarketPlaceHref: getAppMarketplaceUrl(),
      shareFormsHref: getKBShareFormsUrlPublic(),
      embedCTAHref: getKBEmbedCTAUrlPublic(),
      trackingCodeHref: getKBTrackingCodeUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.existingWebsite',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.micrositeCustomPortal',
    getPassedInOptions: () => ({
      websiteBuilderHref: getCMSUrlPublic(true),
      micrositesExamplesHref: getMicrositesExamplesUrl(),
      membershipsHref: getKBMembershipsUrlPublic(),
      membershipsExamplesHref: getMembershipsExamplesUrl(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.micrositeCustomPortal',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.trainDevelopersAndIT',
    getPassedInOptions: () => ({
      quickStartHref: getDevelopersQuickStartGuideUrl(),
      apiHref: getDevelopersAndApiDocsBaseUrl(),
      hostingAndSecurityHref: getSecurityAndComplianceUrl(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.trainDevelopersAndIT',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.migrateExistingWebsite',
    getPassedInOptions: () => ({
      templatesHref: getTemplatesMarketplaceUrl(),
      importToolHref: getKBImportToolUrlPublic(),
      quickStartHref: getDevelopersQuickStartGuideUrl(),
      apiDocsHref: getDevelopersApiDocsUrl(),
      solutionsPartnerHref: getSolutionsMarketplaceUrl(),
      websiteMigrationHref: getWebsiteMigrationUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.migrateExistingWebsite',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.whatSupport',
    getPassedInOptions: () => ({
      langHref: getLanguagesUrlPublic(),
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.whatSupport',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.whatDiscounts',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-contentpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-contentpage'),
      onLinkClick: url => {
        trackClickedLink({
          value: 'content.whatDiscounts',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'content.whenEligibleForNewPricing'
  }],
  [NavItemEnum.BREEZE_INTELLIGENCE]: [{
    questionKey: 'breeze-intelligence.whatAreCredits'
  }, {
    questionKey: 'breeze-intelligence.clearbit',
    getPassedInOptions: () => ({
      clearbit1Href: 'https://ir.hubspot.com/news-releases/news-release-details/hubspot-acquire-b2b-intelligence-leader-clearbit',
      clearbit2Href: 'https://ir.hubspot.com/news-releases/news-release-details/hubspot-completes-acquisition-b2b-intelligence-leader-clearbit',
      onLinkClick: url => {
        trackClickedLink({
          value: 'breeze-intelligence.clearbit',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'breeze-intelligence.whyPackagedUnderBreeze'
  }, {
    questionKey: 'breeze-intelligence.howManyIndexed'
  }, {
    questionKey: 'breeze-intelligence.howDataIsCollected',
    getPassedInOptions: () => ({
      trustCenterHref: getTrustCenterUrl(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'breeze-intelligence.howDataIsCollected',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'breeze-intelligence.qualityOfData'
  }, {
    questionKey: 'breeze-intelligence.compareToOtherProviders'
  }, {
    questionKey: 'breeze-intelligence.howComprehensiveCoverage'
  }, {
    questionKey: 'breeze-intelligence.gdprCompliance',
    getPassedInOptions: () => ({
      privacyRequestFormHref: getPrivacyRequestFormUrl(),
      trustCenterHref: getTrustCenterUrl(),
      privacyPolicyHref: getPrivacyPolicyUrl(),
      dataProcessingHref: getDataProcessingAgreementUrl(),
      trackingCodeHref: getKBTrackingCodeUrlPublic(),
      articleHref: getKBBreezeIntelligenceFAQ(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'breeze-intelligence.gdprCompliance',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'breeze-intelligence.howCrmDataIsUsed',
    getPassedInOptions: () => ({
      articleHref: getKBBreezeIntelligenceFAQ(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'breeze-intelligence.howCrmDataIsUsed',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'breeze-intelligence.whatHappensAfterICancel',
    getPassedInOptions: () => ({
      exportContent: getKBExportContentAndData(),
      exportRecords: getKBExportRecords(),
      exportAdPerformance: getKBExportAdPerformanceData(),
      exportMarketingEmailPerf: getKBExportMarketingEmailPerformanceData(),
      permanentDelete: getKBPermanentDelete(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'breeze-intelligence.whatHappensAfterICancel',
          url,
          type: 'external',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'breeze-intelligence.companyInsights'
  }, {
    questionKey: 'breeze-intelligence.enrichOnlyCompaniesWithinDataset'
  }, {
    questionKey: 'breeze-intelligence.creditValue'
  }],
  [NavItemEnum.SMART_CRM]: [{
    questionKey: 'smart-crm.whatIsSmartCrm'
  }, {
    questionKey: 'smart-crm.howIsAIUsed',
    getPassedInOptions: () => ({
      breezeLink: getSmartCrmAIUrlPublic(),
      breezePricingPageLink: getSmartCrmPricingUrlPublic(),
      onLinkClick: url => {
        trackClickedLink({
          value: 'smart-crm.howIsAIUsed',
          url,
          type: 'internal',
          trackingSource: TRACKING_SOURCES.FAQ
        });
      }
    })
  }, {
    questionKey: 'smart-crm.howDoesSmartCrmWork'
  }, {
    questionKey: 'smart-crm.whatTypeOfSupport'
  }]
};